export default __webpack_public_path__ + "static/media/039-shop in mall.b2aea6f7.svg";